import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { ContextKind } from "../enums/ContextKind";
import { contextKindLabelKey } from "../utils/contextLabels";

/** What the person is in a context: the kind (in the active vocabulary), and the role in an instructor one when it adds something. */
export const useContextDetail = (): ((context: {
  kind: ContextKind;
  wardCount: number;
  roleName?: string | null;
}) => string) => {
  const { t } = useTranslation();
  return useCallback(
    (context) => {
      const kind = t(contextKindLabelKey(context));
      const role = context.roleName ? t(`organization.roles.${context.roleName}`, context.roleName) : null;
      // A plain Instructor reads "Instructor", not "Instructor · Instructor".
      return role && role !== kind ? `${kind} · ${role}` : kind;
    },
    [t],
  );
};
